/**
 * External dependencies
 */
import React from "react";
import { Box } from "@towersystems/towersystems-design-system";
import { get } from "lodash";

/**
 * Internal dependencies
 */
import useReportBuilder from "modules/report-builder/use-report-builder";
import FormInputCheckbox from "components/forms/form-checkbox";

const ConfigureHideLegend = () => {
  const { report, editReport } = useReportBuilder();

  const handleChange = (e) => {
    editReport({ config: { hideLegend: !get(report, "config.hideLegend") } });
  };

  return (
    <Box>
      <FormInputCheckbox
        onChange={handleChange}
        label="Hide Legend"
        checked={!!get(report, "config.hideLegend")}
      />
    </Box>
  );
};

export default ConfigureHideLegend;
